import { FC, useCallback, useState } from "react";
import { LoyaltyTagStatusVariantT } from "components/atoms/LoyaltyTagStatusRank/types";
import { StatusRank } from "components/atoms/LoyaltyRankStatus/types";
import LoyaltyRankDetailMobile from "components/organisms/LoyaltyRankDetailMobile";
import { RANK_LEVEL_LOYALTY_IMAGES } from "constants/loyalty";
import { RewardItemT } from "components/molecules/LoyaltyListRewards/types";
import "./styles.sass";

type LoyaltyListRanksMobileProps = {
  ranks: Array<{
    name: string;
    statusRank: LoyaltyTagStatusVariantT;
    rewards: RewardItemT[];
    levels: Array<{
      title: string;
      status: StatusRank;
      rewards: RewardItemT[];
      requirement: number;
      nextRequirement: number;
    }>;
  }>;
  userExperience: number;
};

const LoyaltyListRanksMobile: FC<LoyaltyListRanksMobileProps> = (props) => {
  const { ranks, userExperience } = props;
  const [opens, setOpens] = useState<string[]>([]);

  const onOpen = useCallback(
    (newName: string) => {
      if (opens.includes(newName)) {
        setOpens((prevState) => prevState.filter((name) => name !== newName));
        return;
      }
      setOpens((prevState) => [...prevState, newName]);
    },
    [opens],
  );

  const statusRankRewards = (rank: {
    rewards: RewardItemT[];
  }): "complete" | "progress" | "close" =>
    // eslint-disable-next-line no-nested-ternary
    rank?.rewards?.every((rew) => !rew.isClose)
      ? "complete"
      : rank?.rewards?.some((rew) => !rew.isClose)
        ? "progress"
        : "close";

  return (
    <div className="LoyaltyListRanksMobile">
      {ranks?.map((rank, index, arr) => (
        <LoyaltyRankDetailMobile
          key={rank.name}
          name={rank.name}
          isOpen={opens.includes(rank.name)}
          statusRank={rank.statusRank}
          statusRankRewards={statusRankRewards(rank)}
          rewardsRank={rank.rewards}
          levels={rank.levels}
          image={RANK_LEVEL_LOYALTY_IMAGES[index].rank}
          handleClick={() => onOpen(rank.name)}
          userExperience={userExperience}
          isLastRank={arr.length - 1 === index}
          isFirst={index === 0}
        />
      ))}
    </div>
  );
};

export default LoyaltyListRanksMobile;
